/**
 * Which month the delivery screen is showing, as it lives in the URL.
 *
 * ITS OWN MODULE, AND THE SPLIT IS A BUNDLE DECISION — the same one `statementSearch.ts` and
 * `auditSearch.ts` record. `validateSearch` runs during ROUTING, so whatever this file imports
 * lands in the eager bundle on every page of the app. It therefore imports NOTHING.
 *
 * IN THE URL rather than in component state, for the reason a month-end screen always is: this is
 * the page an operator sends to a colleague ("August is queued, can you check before I send"),
 * reloads after fixing a contact record, and comes back to when an owner rings.
 */

export interface DeliverySelection {
  /** The month, as its first day. Absent means "the month just gone", resolved by the screen. */
  period?: string;
}

const PERIOD = /^\d{4}-\d{2}-01$/;

/**
 * A period that is not the first of a month is DROPPED rather than rounded down.
 *
 * `?period=2026-08-14` is a URL somebody edited by hand, and quietly reinterpreting it as August
 * would teach them the page accepts dates when what it accepts is months.
 */
export function parseDeliverySearch(search: Record<string, unknown>): DeliverySelection {
  return typeof search.period === 'string' && PERIOD.test(search.period)
    ? { period: search.period }
    : {};
}
